// 🚀 main.jsx - Point d'entrée de l'application React
// Configure le root React avec StrictMode et BrowserRouter
// Ce fichier est le premier à être exécuté par Vite

import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './index.css'

// Message console stylé DOMELVIA
console.log(
  '%c' + `
  ██████╗  ██████╗ ███╗   ███╗███████╗██╗    ██╗   ██╗██╗ █████╗ 
  ██╔══██╗██╔═══██╗████╗ ████║██╔════╝██║    ██║   ██║██║██╔══██╗
  ██║  ██║██║   ██║██╔████╔██║█████╗  ██║    ██║   ██║██║███████║
  ██║  ██║██║   ██║██║╚██╔╝██║██╔══╝  ██║    ╚██╗ ██╔╝██║██╔══██║
  ██████╔╝╚██████╔╝██║ ╚═╝ ██║███████╗███████╗╚████╔╝ ██║██║  ██║
  ╚═════╝  ╚═════╝ ╚═╝     ╚═╝╚══════╝╚══════╝ ╚═══╝  ╚═╝╚═╝  ╚═╝`,
  'color: #ef4444; font-weight: bold; font-size: 10px; line-height: 1.2;'
)
console.log('%c ', 'font-size: 4px;')
console.log(
  '%c🔍 Qu\'est-ce que tu fais ici petit curieux ?! %c😏',
  'color: #1f2937; font-size: 16px; font-weight: bold;',
  'font-size: 20px;'
)
console.log('%c ', 'font-size: 4px;')
console.log(
  '%c💼 Dev freelance ou en recherche ? %cOn recrute des talents !',
  'color: #1f2937; font-size: 14px;',
  'color: #ef4444; font-size: 14px; font-weight: bold;'
)
console.log(
  '%cProjets web, mobile, IA... On a ce qu\'il te faut. %c🚀',
  'color: #6b7280; font-size: 13px;',
  'font-size: 16px;'
)
console.log('%c ', 'font-size: 6px;')
console.log(
  '%c📧 Contact : %crecrutement@domelvia.com',
  'color: #1f2937; font-size: 13px; font-weight: bold;',
  'color: #ef4444; font-size: 13px; font-weight: bold;'
)

// Création du root React et rendu de l'application
createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
